"use client";

import { useEffect, useRef } from "react";
import { motion } from "framer-motion";

export default function InfraHero() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("visible");
        });
      },
      { threshold: 0.1 }
    );
    ref?.current?.querySelectorAll(".reveal")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <motion.section
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="relative pt-40 pb-24 bg-[#0B0F14] overflow-hidden"
    >
      <div className="animated-grid absolute inset-0 z-0 opacity-50" />
      <div
        className="absolute inset-0 z-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 50% 60% at 50% 0%, rgba(0,230,118,0.07) 0%, transparent 70%)",
        }}
      />
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="tag-badge mx-auto mb-6 inline-flex reveal">
          Infrastructure
        </div>
        <h1 className="hero-title text-[#F0F4F8] max-w-4xl mx-auto mb-6 reveal reveal-delay-1">
          Enterprise-Level{" "}
          <span className="text-[#00E676]">Advertising Infrastructure.</span>
        </h1>
        <p className="text-[#6B7A8D] text-lg max-w-2xl mx-auto leading-relaxed reveal reveal-delay-2">
          Agency ad account systems engineered for volume, stability, and
          operational continuity. Designed for advertisers who require
          infrastructure that matches their ambition.
        </p>
      </div>
    </motion.section>
  );
}